const SidemenuOptions = {
  SWITCHER: 0,
  BACK: 1,
  SEARCH: 2,
  FUNCTIONS: 3,
  DATASETS: 4,
  VARIABLES: 5,
  PIPELINES: 6,
  LOGS: 7,
  MODEL_WEIGHT: 8
};

export const STUDIO_TYPE = {
  FUNCTIONS: "FUNCTIONS",
  PIPELINE: "PIPELINE",
  SWITCHER: "SWITCHER"
};

export default SidemenuOptions;
